import * as Sentry from "@sentry/react"
import { fetchAuthenticityToken } from "app/scripts/refresh_form_authenticity_token"

export async function xhrPromise(url, options) {
  await ensureOptions(options)

  return new Promise((resolve, reject) => {
    window.$.ajax(url, options)
      .done(resolve)
      .fail((jqXHR, textStatus, errorThrown) =>
        reject({
          response: jqXHR.responseJSON || jqXHR.responseText,
          status: jqXHR.status,
          error: errorThrown,
        })
      )
  })
}

export function logRejectedXHRPromise(response, status, error) {
  const context = { tags: { status }, extra: { response } }
  if (error instanceof Error) {
    Sentry.captureException(error, context)
  } else if (typeof error === "string" && error.length > 0) {
    Sentry.captureMessage(`XHR Promise failed with error: ${error}`, context)
  } else {
    Sentry.captureMessage(`XHR Promise failed with status: ${status}`, context)
  }

  if (window.App.allowDebugErrorMessages) {
    console.warn("catch", response, status, error)
  }
}

export function rejectedXHRPromiseLogger(callback = () => true) {
  return function ({ response, status, error }) {
    logRejectedXHRPromise(response, status, error)
    return callback({ response, status, error })
  }
}

async function ensureOptions(options) {
  if (!options.method || options.method.toLowerCase() === "get") return

  options.headers = Object.assign(
    { "X-CSRF-Token": await fetchAuthenticityToken() },
    options.headers
  )
  options.contentType = options.contentType || "application/json"
  if (
    options.contentType === "application/json" &&
    typeof options.data !== "string"
  ) {
    options.data = JSON.stringify(options.data)
  }
}
